import {
  ERROR_TECNICO,
  INDIVIDUO_NEGATIVO,
  RECHAZADO_OTROS,
  ERROR_NOSIS,
  RECHAZADO,
  GRACIAS
} from "@/config/constants/step-constants";

describe("Step Constants Test", () => {
  it("should have the correct value for ERROR_TECNICO", () => {
    expect(ERROR_TECNICO).toEqual("error-1");
  });

  it("should have the correct value for INDIVIDUO_NEGATIVO", () => {
    expect(INDIVIDUO_NEGATIVO).toEqual("error-2");
  });

  it("should have the correct value for RECHAZADO_OTROS", () => {
    expect(RECHAZADO_OTROS).toEqual("error-3");
  });

  it("should have the correct value for ERROR_NOSIS", () => {
    expect(ERROR_NOSIS).toEqual("error-4");
  });

  it("should have the correct value for RECHAZADO", () => {
    expect(RECHAZADO).toEqual("error-5");
  });

  it("should have the correct value for GRACIAS", () => {
    expect(GRACIAS).toEqual("gracias");
  });
});
